/**
 * Como se lê a hora de um evento de agenda.
 *
 * A intimação nem sempre diz a hora. Quando não diz, o backend ancora o
 * evento à meia-noite local e marca `hora_conhecida: false` — e a tela tem de
 * dizer que não sabe, em vez de anunciar "00:00" ao lado de "Sessão de
 * julgamento". Em 29/09/2026 eram 8 dos 20 eventos do acervo.
 *
 * Um lugar só porque a hora é escrita em três telas (item de agenda,
 * calendário, detalhe do evento), e três cópias de uma regra divergem.
 */

/** O que a tela mostra no lugar da hora que ninguém informou. */
export const SEM_HORA = 'sem hora';

/** Por que não há hora — para o `title` de quem passa o ponteiro. */
export const SEM_HORA_EXPLICACAO = 'A intimação não informou o horário';

interface ComHorario {
  data_inicio: string;
  hora_conhecida?: boolean;
}

/** A hora do evento, ou `null` quando a intimação não a informou.
 *
 *  `hora_conhecida` ausente vale como conhecida: evento criado à mão pelo
 *  usuário tem a hora que ele digitou, e caller antigo não deve regredir. */
export function horaDoEvento(evento: ComHorario): string | null {
  if (evento.hora_conhecida === false) return null;
  return new Date(evento.data_inicio).toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** A hora, ou `SEM_HORA` — para onde a linha precisa de algum texto. */
export function horaOuSemHora(evento: ComHorario): string {
  return horaDoEvento(evento) ?? SEM_HORA;
}
